module.exports = __webpack_public_path__ + "static/media/company.3f1b6962.svg";